/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { DischargePlansViewModel } from './DischargePlansViewModel'; 

export function getDischargePlansOptions(certificationPeriodId: string, onSuccess?: (result: DischargePlansViewModel) => void) {
	return queryOptions({
		queryKey: ['discharge-plans', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/discharges/queries/getdischargeplans/' + certificationPeriodId;
			const resp = await axios.get<DischargePlansViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId)
	});
}